import inview from './inview.js';
import pageLoadedEffect from './jquery.pageLoadedEffect';

export default function () {

  if (location.hash.match('intro')) window.is_visited = false;

  // ▼ ▼ ▼ 遷移完了後の処理 ▼ ▼ ▼
  const pageMoveAfterFunc = () => {
    $('.js-home-intro').remove(); // <- イントロ要素を削除
    $.when(
      setTimeout(() => $('body').addClass('is-aftermove'), 150),
    ).done(() => {
      setTimeout(() => $('.c-pagemove').fadeOut(200), 650);
      setTimeout(() => inview(), 200);
    });
  }
  // ▲ ▲ ▲ 遷移完了後の処理 ▲ ▲ ▲

  // ▼ ▼ ▼ 訪問・未訪問で遷移完了後処理のタイミングをずらす ▼ ▼ ▼
  let move_after_time = 4600;
  if ($('body').hasClass('home')) move_after_time = 5300;
  $(document).ready(() => {
    if (is_visited) {
      // 訪問済みの場合
      $.when(
        pageLoadedEffect(),
      ).done(() => pageMoveAfterFunc());
    } else {
      // 未訪問の場合
      $.when(
        pageLoadedEffect(),
      ).done(() => {
        $('.c-pagemove').hide();
        setTimeout(() => $('body').addClass('is-intro-shape-hide'), 3500);
        setTimeout(() => pageMoveAfterFunc(), move_after_time);
      });
    }
  });
  // ▲ ▲ ▲ 訪問・未訪問で遷移完了後処理のタイミングをずらす ▲ ▲ ▲
}
